if(!customElements.get('cart-quantity-selector')){
    class QuantitySelector extends HTMLElement {
        constructor(){
            super();

            this.buttonPlus = this.querySelector('.button-plus');
            this.buttonMinus = this.querySelector('.button-minus');
            this.buttonRemove = this.querySelector('.button-remove');
            this.input = this.querySelector('input[type="number"]');
            this.error = this.querySelector('.error');

            this.section = this.closest('[data-section-id]');
            this.sectionId = this.section? this.section.dataset.sectionId : null;
            this.sectionCartItems = this.section.querySelector('.cart-items-wrapper');
            this.sectionCheckout = this.section.querySelector('.checkout-wrapper');

            this.currentProduct = this.closest('.cart-product');
            this.currentIndex = this.currentProduct.dataset.index;

            this.buttonCheckout = this.section.querySelector('button[name="checkout"]');
            this.currentProductDetails = this.currentProduct.querySelector('.cart-product__details');
            this.currentProductSubtotal = this.currentProduct.querySelector('.cart-product__subtotal');

            this.shippingProgressBarWrapper = this.section.querySelector(".shipping-progress-bar-wrapper");

            this.buttonPlus.addEventListener('click', this.updateQuantityPlus.bind(this));
            this.buttonPlus.addEventListener('keydown', e => {
                if(e.key == 'Enter'){
                    this.updateQuantityPlus();
                }
            });
            this.buttonMinus.addEventListener('click', this.updateQuantityMinus.bind(this));
            this.buttonMinus.addEventListener('keydown', e => {
                if(e.key == 'Enter'){
                    this.updateQuantityMinus();
                }
            });

            this.buttonRemove.addEventListener('click', this.removeProduct.bind(this));
            this.buttonRemove.addEventListener('keydown', e => {
                if(e.key == 'Enter'){
                    this.removeProduct();
                }
            });

            // update input value to only number
            this.input.addEventListener('input', (e) => {
                let currentQuantitySize = e.target.value.replace(/[^0-9]/g, '');
                if(currentQuantitySize.trim() == "" || parseInt(currentQuantitySize) < 0){
                    currentQuantitySize = 1;
                }else{
                    currentQuantitySize = parseInt(currentQuantitySize);
                }
                e.target.value = currentQuantitySize;
            });

            // update quantity when input value change
            this.input.addEventListener('change', (e) => {
                const inputValue = parseInt(e.target.value) || 0;
                if(inputValue < 0){
                    e.target.value = 0;
                    return;
                }

                e.target.value = inputValue;
                this.updateQuantity();
            });
        }

        connectedCallback(){
            this.onRemoveProductUnsubscriber = PubSub.subscribe(
                PubSub.events.cartUpdate, (event) => {
                    if(event.source === 'cart-item-remove'){
                        this.updateProductIndex();
                    }
                }
            );
        }

        disconnectedCallback(){
            if(this.onRemoveProductUnsubscriber){
                this.onRemoveProductUnsubscriber();
            }
        }

        updateProductIndex(){
            this.currentProduct = this.closest('.cart-product');
            this.currentIndex = this.currentProduct.dataset.index;
        }

        updateQuantity(displayedMessage = ''){
            const inputValue = this.input.value;
            const newInputValue = parseInt(inputValue);

            var formData = new FormData();
            formData.append("line", `${this.currentIndex}`);
            formData.append("quantity", newInputValue);
            formData.append("sections_url", window.location.pathname);
            formData.append("sections", [this.sectionId]);
 
            this.loadingItem();
            this.submitToCart(formData, displayedMessage);
        }

        updateQuantityPlus(){
            const inputValue = this.input.value;
            const newInputValue = parseInt(inputValue) + 1;

            var formData = new FormData();
            formData.append("line", `${this.currentIndex}`);
            formData.append("quantity", newInputValue);
            formData.append("sections_url", window.location.pathname);
            formData.append("sections", [this.sectionId]);

            this.loadingItem();
            this.submitToCart(formData);
        }

        updateQuantityMinus(){
            const inputValue = this.input.value;
            const newInputValue = parseInt(inputValue) - 1;

            var formData = new FormData();
            formData.append("line", `${this.currentIndex}`);
            formData.append("quantity", newInputValue);
            formData.append("sections_url", window.location.pathname);
            formData.append("sections", [this.sectionId]);

            this.loadingItem();
            this.submitToCart(formData);
        }

        removeProduct(){
            var formData = new FormData();
            formData.append("line", `${this.currentIndex}`);
            formData.append("quantity", 0);
            formData.append("sections_url", window.location.pathname);
            formData.append("sections", [this.sectionId]);

            this.loadingItem();
            this.submitToCart(formData);
        }

        loadingItem(){
            this.classList.add('disabled');

            this.currentProduct.querySelectorAll('.loading').forEach(item => {
                item.classList.remove('hidden');
                item.closest('.cart-product__subtotal')?.setAttribute('data-loading', 'true');
            });

            if(this.buttonCheckout){
                this.buttonCheckout.setAttribute('disabled', 'disabled');
            }
        }

        submitToCart(formData, displayedMessage = ''){
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];
            config.body = formData;

            fetch(`${routes.cart_change_url}`, config)
            .then(res => res.json())
            .then(res => {
                if(displayedMessage !== ''){
                    this.error.innerHTML = '';
                }

                if(res.status){ // error
                    this.error.innerHTML = `${res.message}`;

                    if(res.status === 422){ // quantity exceed available quantity
                        const message = res.message;

                        this.error.innerHTML = message;
                        // extract available quantity from message, the message contains number.
                        const availableNumbers = message.match(/\d+/g)?.map(Number) || [];

                        if(availableNumbers.length > 0){
                            const availableQuantity = availableNumbers[0];
                            this.input.value = availableQuantity;

                            this.updateQuantity(message);
                        }
                    }
                }else if(res.token){ // proceed

                    const pageText = res.sections[[this.sectionId]];
                    const pageHTML = new DOMParser().parseFromString(pageText, 'text/html');

                    if(res.item_count === 0){ // empty cart
                        this.sectionCheckout.setAttribute('aria-hidden', 'true');
                        if(this.shippingProgressBarWrapper){
                            this.shippingProgressBarWrapper.setAttribute('aria-hidden', 'true');
                        }

                        const cartItemsHTML = pageHTML.querySelector('.cart-items-wrapper');
                        this.sectionCartItems.innerHTML = cartItemsHTML.innerHTML;
                    }else{
                        const cartItemHTML = pageHTML.querySelector(`.cart-product[data-index="${this.currentIndex}"]`);

                        if(cartItemHTML){
                            if(cartItemHTML.dataset.productId !== this.currentProduct?.dataset.productId){ // item in the middle removed
                                this.currentProduct.remove();

                                const cartProducts = this.section.querySelectorAll('.cart-product');
                                cartProducts.forEach((item, index) => {
                                    item.setAttribute('data-index', index + 1);
                                });

                                PubSub.publish(PubSub.events.cartUpdate, {
                                    source: 'cart-item-remove',
                                    productId: this.currentProduct?.dataset.productId
                                });
                            }else{ // item removed
                                if(this.currentProductDetails){
                                    this.currentProductDetails.innerHTML = cartItemHTML.querySelector('.cart-product__details').innerHTML;
                                };
                                if(this.currentProductSubtotal){
                                    this.currentProductSubtotal.innerHTML = cartItemHTML.querySelector('.cart-product__subtotal').innerHTML;
                                }
                            }
                        }else{
                            this.currentProduct.remove();
                        }
                        
                        const checkoutButton = pageHTML.querySelector('button[name="checkout"]');
                        if(this.buttonCheckout){
                            this.buttonCheckout.innerHTML = checkoutButton.innerHTML;
                            this.buttonCheckout.removeAttribute('disabled');
                        }

                        // free shipping progress bar in cart page
                        const freeShippingProgressBarWrapper = pageHTML.querySelector('.shipping-progress-bar-wrapper');
                        if(this.shippingProgressBarWrapper && freeShippingProgressBarWrapper){
                            this.shippingProgressBarWrapper.querySelector(".label").innerHTML = freeShippingProgressBarWrapper.querySelector(".label").innerHTML;
                            const neededPercentage = freeShippingProgressBarWrapper.dataset.percentage;
                            this.shippingProgressBarWrapper.style.setProperty('--free-shipping-progress', neededPercentage);
                        }
                    }

                    this.getCartSize();
                }
            }).finally(() => {
                this.classList.remove('disabled');
                this.currentProduct.querySelectorAll('.loading').forEach(item => {
                    item.classList.add('hidden');
                    item.closest('.cart-product__subtotal')?.setAttribute('data-loading', 'false');

                });

                if(this.input){
                    this.input.value = this.input.value < 0? 0 : this.input.value;
                }

                // Re-query error element AFTER DOM updates, then set the message
                if(displayedMessage){
                    const error = this.currentProduct.querySelector('.error');
                    if(error){
                        error.innerHTML = displayedMessage;
                    }
                }
            });
        }

        getCartSize(){
            fetch(`/?section_id=header-cart-icon`)
            .then(res => {
                if (!res.ok) {
                    var error = new Error(res.status);
                    throw error;
                }
                return res.text();
            })
            .then((text) => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-header-cart-icon').innerHTML;
    
                document.querySelectorAll('.cart-icon .cart-item-size').forEach(item => {
                    const resultsHTML = resultsMarkup.trim();
                    item.innerHTML = `${resultsHTML}`;

                    item.setAttribute('aria-hidden', resultsHTML == ""? "true" : "false");
                });
            });
        }
    }
    customElements.define('cart-quantity-selector', QuantitySelector);
}